<atx-modal-header class="border-0" (dismiss)="close()">
  <div class="px-1 pt-2 font-weight-bold">Terms of service</div>
</atx-modal-header>

<atx-modal-body class="pl-4 pt-2">
  <h1>Terms and Conditions for the ECCO Partner Site</h1>

  <p>
    Please read the following terms and conditions carefully before using this
    Website. By using this Website, you agree and are bound to the following
    terms and conditions. If you do not agree, please exit.
  </p>

  <h3>Users</h3>

  <p>
    ECCO Sko A/S will make access to this Website possible only for Business
    Partners of ECCO Sko A/S and their authorized staff with a legitimate
    interest in using this Website, License Partners, employees of ECCO Sko A/S,
    its affiliates, subsidiaries and branches thereof and their authorized
    staff. However, ECCO Sko A/S retains all rights to discontinue or limit
    access to this Website as it may determine in its sole discretion.
  </p>

  <p>
    The user will be given a personal password. The user has the sole
    responsibility for the use/misuse of his/her personal Website password.
    <br />
    <br />
    Copyright and other Intellectual Property Rights - all material on this
    Website, including, but not limited to, Web pages, programs, graphics,
    images, audio, video, scripts and text, are protected by copyright belonging
    to ECCO Sko A/S, Industrivej 5, 6261 Bredebro, Denmark. All rights are
    reserved. You should assume that everything you see or read on this Website
    is protected by copyright unless otherwise noted. You may not reproduce,
    publish, display, remove, delete, add to, distribute, modify, transmit,
    reuse, re-post, or use the content of this Website for public or commercial
    purposes without ECCO Sko A/S´ prior written permission, with the exception
    of all contents on this Website which are expressly released for use by ECCO
    Sko A/S. <br />
  </p>
  <h3>Trademarks</h3>

  ECCO and all ECCO logos are registered and unregistered trademarks of ECCO Sko
  A/S. Other trademarks are owned by the respective trademark owners.

  <h3>No License</h3>

  Unless otherwise provided herein, nothing contained on this Website grants, or
  should be construed as granting, by implication or otherwise, any license or
  right to use any copyright, trademark or other intellectual property rights
  displayed or used on or in connection with this Website without the written
  permission of ECCO Sko A/S or such third party that may own the trademarks,
  copyrights or other intellectual property rights displayed or used on or in
  connection with this Website. Any misuse of any of the trademarks, copyrights
  or other intellectual property rights displayed or used on or in connection
  with this Website is strictly prohibited. <br />

  <h3>Online Orders ("E-Sales")</h3>

  E-Sales procedures can be carried out within this Website. With regard to
  electronic orders and deliveries the General Terms and Conditions of Sale to
  Business Partners of ECCO Sko A/S, its subsidiaries and branches thereof,
  License Partner or Business Partner as they exist at the time the order is
  placed and known by the partner, shall apply. Conclusion of the contract is
  made with the invoicing party. Placed orders will be transferred to the
  respective contract partner for processing and delivering. <br />

  <h3>Confidentiality</h3>

  As a user of this Website you acknowledge and agree that the contents of this
  Website are confidential and proprietary to ECCO Sko A/S. You agree not to
  disclose to any person any trade secrets and/or confidential information of
  ECCO Sko A/S, its affiliates, subsidiaries and branches thereof at any time
  and not to use, or cause another to use, any information conveyed by to you
  through this Website for any purpose other than as set forth herein. <br />

  <h3>Submissions</h3>

  All remarks, suggestions, creative ideas, graphics, comments, messages,
  postings, data, concepts or other information communicated, disclosed,
  submitted or offered to ECCO Sko A/S through or in connection with this
  Website shall be considered as being communicated on a non-confidential and
  not proprietary basis and shall become and remain the property of ECCO Sko
  A/S. ECCO Sko A/S reserves the right to use such information in its sole
  discretion.&nbsp;Such disclosure, submission or offer of any submission shall
  constitute an assignment to ECCO Sko A/S of all rights, title and interests in
  all copyrights and other rights in the submission. ECCO Sko A/S is, and shall
  be, under no obligation (i) to maintain any submission in confidence; (ii) to
  pay anyone any compensation for or in connection with the use of any
  submission; or (iii) to respond to any submission. You represent and warrant
  that no submission by you will violate any right of any third party,
  including, but not limited to, copyright, trademark, patent, trade secret,
  privacy or other personal or proprietary right. By making any submission
  through, in connection with or related to this Website, you agree that ECCO
  Sko A/S has the right (but not the obligation) to copy, publish, distribute or
  use such submission, or any part or parts thereof, for any purpose, including
  but limited to, advertising, promotional, product development or other
  commercial purposes, without compensation to you or to any other person.
  <br />
  <br />
  <p>
    ECCO Sko A/S does not, cannot and does not agree to consider or review every
    submission, and is not liable or responsible for the content of any material
    posted on this Website by users. You agree not to upload, post distribute or
    otherwise publish on this Website any material that (i) is defamatory,
    obscene, abusive, pornographic, threatening or an invasion of privacy; (ii)
    infringes the intellectual property rights, including but not limited to any
    copyright, patent, trade secret or trademarks, of any person or entity; or
    (iii) is illegal in any way or advocates illegal activity.
  </p>

  <p class="popupbigtext">
    ECCO Sko A/S uses reasonable efforts to include accurate and up-to-date
    information on the Website. However, ECCO Sko A/S makes no warranties or
    representations as to the accuracy of the information. ECCO Sko A/S assumes
    no liability or responsibility for any errors or omissions in the contents
    of this Website.
  </p>

  <p class="popupbigtext">
    A submission is not regarded as an agreement before an order confirmation
    has been received by the user.<br />
  </p>

  <h3>Disclaimer</h3>

  You assume total responsibility and risk for your use, including entering,
  using or browsing of this Website. To the fullest extent permissible pursuant
  to applicable law, this site is provided "as is" without warranty of any kind,
  either express or implied, including, but not limited to, the implied
  warranties of merchantability and fitness for a particular purpose, and the
  warranties of title, non-infringement and accuracy. ECCO Sko A/S will not be
  liable for any damages (including, but not limited to, special, indirect,
  incidental, consequential or punitive damages) or injury caused by any failure
  of performance, error, omission, interruption, defect, delay in operation of
  transmission, computer virus, online failure or negligence by ECCO Sko A/S.
  (Although ECCO Sko A/S may from time to time monitor or review postings,
  transmissions and the like on the Website, it is under no obligation to do so
  and assumes no responsibility or liability arising from the content of any
  such locations nor from any error, defamation, libel, slander, omission,
  falsehood, obscenity, pornography, profanity, danger or inaccuracy contained
  in any information within such locations on this Website.)<br />

  <h3>Links</h3>

  <p>
    This site may be linked to other sites, which are not maintained by ECCO Sko
    A/S; ECCO Sko A/S is not responsible for the availability of or any content
    or material contained in, or obtained through those sites. Any link to
    another site and reference to third party information, products or services
    linked to this Website, is not and should not be construed as, an express or
    implied endorsement by ECCO Sko A/S. Any questions or comments relating to
    such other sites should be addressed to the operator or operators of those
    sites.
  </p>

  <h3>Revision of these Terms and Conditions</h3>

  <p>
    ECCO Sko A/S may at any time revise these terms and conditions by updating
    this posting. You are bound by any such revisions and should therefore
    periodically visit this page to review the current terms and conditions by
    which you are bound.
  </p>

  <h3>Marketing</h3>

  <p>
    We have collected your contact information as a customer. The information
    will be used for marketing purposes by ECCO Sko A/S, its affiliates,
    subsidiaries and branches thereof, partners and authorized retailers. None
    of the information will be sold to any third party in any manner whatsoever.
    The marketing tools used by ECCO, its affiliates, subsidiaries and branches
    thereof, partners and authorized retailers may be email, sms, mms and
    printed material. If you do not wish to receive marketing materials please
    contact your official contact person within ECCO.<br />
  </p>
</atx-modal-body>
